import { StateCreator } from "zustand";
import { TerritoryData } from "../../../domain/models/territory-data";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteFetchHeadquarterMaster } from "../../../data/usecases/remote-fetch-headquarter";
import { FetchHeadquarterMaster } from "../../../domain/useages/fetch-headquarter";


export interface FetchHeadQuarterListTourInterface {
  FetchHeadQuarterListTour: FetchHeadquarterMaster;
  FetchHeadQuarterListTourState: FetchState;
  fetchHeadQuarterListTour: Function;
}

const initialStates = {
  FetchHeadQuarterListTour: {} as FetchHeadquarterMaster,
  FetchHeadQuarterListTourState: FetchState.DEFAULT,
};
const axiosHttpClient = AxiosHttpClient.getInstance();


const useFetchHeadQuarterListTourSlice: StateCreator<
  FetchHeadQuarterListTourInterface
> = (set, get) => ({
  ...initialStates,
  fetchHeadQuarterListTour: async (payload: FetchHeadquarterMaster.Params) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchHeadquarterMaster = new RemoteFetchHeadquarterMaster(
      `${BASE_URL}${Endpoints.FETCH_HEADQUARTER_MASTER}`,
      axiosHttpClient
    );
   
    let result = await remoteFetchHeadquarterMaster.fetch(payload);
    return result;
}
  
});
export default useFetchHeadQuarterListTourSlice;
